import axios from "axios";
import React, { useEffect, useState } from "react";
import { baseUrl } from "../../helper/urls";
import { useSelector } from "react-redux";
import {
  Autocomplete,
  Box,
  Button,
  Divider,
  TextField,
  Typography,
} from "@mui/material";
import Swal from "sweetalert2";
import { toast, ToastContainer } from "react-toastify";

export default function ApproveSlotRequest({
  rowData,
  handleClose,
  fetchBookingReq,
}) {
  const { token } = useSelector((state) => state.auth);

  const [counselorList, setCounselorList] = useState([]);
  // console.log("counselorList: ", counselorList);
  const [priceList, setPriceList] = useState([]);
  console.log("priceList: ", priceList);
  const [selectedCounselors, setSelectedCounselors] = useState(null);
  console.log("selectedCounselors: ", selectedCounselors);
  const [selectedServiceType, setSelectedServiceType] = useState(null);
  console.log("selectedServiceType: ", selectedServiceType);
  const [selectedServiceObject, setSelectedServiceObject] = useState(null);
  console.log("selectedServiceObject: ", selectedServiceObject);
  const [slots, setSlots] = useState("");
  console.log("slots: ", slots);
  const [discount, setDiscount] = useState("");
  console.log("discount: ", discount);
  const [totalCost, setTotalCost] = useState(0);
  console.log("totalCost: ", totalCost);
  const [pricePerHour, setpricePerHour] = useState(0);
  console.log("pricePerHour: ", pricePerHour);
  const [discountPrice, setdiscountPrice] = useState();
  console.log("discountPrice: ", discountPrice);
  const [availableSlots, setavailableSlots] = useState(0);
  console.log("availableSlots: ", availableSlots);
  const [counselorPrice, setcounselorPrice] = useState(0);
  console.log("counselorPrice: ", counselorPrice);
  const [adminPrice, setadminPrice] = useState(0);
  console.log("adminPrice: ", adminPrice);

  // Auto-select counselor based on rowData.counselorId
  useEffect(() => {
    if (counselorList.length > 0 && rowData.counselorId) {
      const defaultCounselor = counselorList.find(
        (counselor) => counselor.id === rowData.counselorId
      );
      if (defaultCounselor) {
        setSelectedCounselors(defaultCounselor);
      }
    }
  }, [counselorList, rowData.counselorId]);

  useEffect(() => {
    const fetchAvailableSlots = async () => {
      if (!selectedCounselors) return;

      try {
        const response = await axios.get(
          `${baseUrl}/slots/counselor/getAvailableSlot/${selectedCounselors.id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = response.data.data.count || 0;
        setavailableSlots(data);
      } catch (error) {
        console.error("Failed to load price list", error);
      }
    };

    fetchAvailableSlots();
  }, [selectedCounselors]);

  useEffect(() => {
    const fetchPriceList = async () => {
      if (!selectedCounselors) {
        setPriceList([]);
        setSelectedServiceType(null);
        setSelectedServiceObject(null);
        return;
      }

      try {
        const response = await axios.get(
          `${baseUrl}/api/counselors/pricePerHourList/${selectedCounselors.id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = response.data.data || [];
        setPriceList(data);

        if (data.length === 0) {
          setSelectedServiceType(null);
          setSelectedServiceObject(null);
        }
      } catch (error) {
        console.error("Failed to load price list", error);
        setPriceList([]);
        setSelectedServiceType(null);
        setSelectedServiceObject(null);
      }
    };

    fetchPriceList();
  }, [selectedCounselors]);

  const fetchCounselors = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/counselors/counselorlist`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setCounselorList(response.data.data || []);
    } catch (err) {
      console.error("Failed to load counselors", err);
    }
  };

  const handleSendPayment = async () => {
    if (!selectedServiceObject) {
      toast.error("please select service type");
      return;
    }
    if (!slots) {
      toast.error("please select atleast 1 slot");
      return;
    }

    try {
      await axios.post(
        `${baseUrl}/api/booking_req/update/${rowData.id}`,
        {
          approved_slots: slots,
          discount_percentage: discount,
          discount_amount: discountPrice,
          total_amount: totalCost,
          counselor_amount: counselorPrice,
          admin_amount: adminPrice,
          counselorId: selectedCounselors.id,
          studentId: rowData.studentId,
          rateId: selectedServiceObject.id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      Swal.fire("Success", "Approved slots updated successfully", "success");
      handleClose();
      fetchBookingReq();
    } catch (error) {
      Swal.fire("Error", "Failed to update approved slots", "error");
      console.error("Update Error:", error);
    }
  };

  useEffect(() => {
    fetchCounselors();
  }, []);

  const uniqueServiceTypes = Array.from(
    new Set(priceList.map((p) => p.service_type))
  );

  useEffect(() => {
    if (selectedServiceType && selectedCounselors) {
      const matched = priceList.find(
        (item) =>
          item.service_type === selectedServiceType &&
          item.counselorId === selectedCounselors?.id
      );
      setSelectedServiceObject(matched || null);
    } else {
      setSelectedServiceObject(null);
    }
  }, [selectedCounselors, selectedServiceType, priceList]);

  // useEffect(() => {
  //   const slotCount = parseInt(slots, 10);

  //   if (!selectedServiceObject || isNaN(slotCount)) {
  //     setTotalCost(0);
  //     setpricePerHour(0);
  //     setdiscountPrice(0);
  //     return;
  //   }

  //   let rate = 0;

  //   if (slotCount >= 1 && slotCount <= 4) {
  //     rate = parseFloat(selectedServiceObject?.rate_1_slot || "0");
  //   } else if (slotCount >= 5 && slotCount <= 9) {
  //     rate = parseFloat(selectedServiceObject?.rate_5_slot || "0");
  //   } else if (slotCount >= 10 && slotCount <= 14) {
  //     rate = parseFloat(selectedServiceObject?.rate_10_slot || "0");
  //   } else if (slotCount >= 15) {
  //     rate = parseFloat(selectedServiceObject?.rate_15_slot || "0");
  //   }

  //   const commission = parseFloat(selectedServiceObject?.commission || "0");

  //   setcounselorPrice(rate * slotCount);

  //   const pricePerHour = rate + (commission / 100) * rate;
  //   const totalPriceBeforeDiscount = pricePerHour * slotCount;
  //   const discountAmount = (discount / 100) * totalPriceBeforeDiscount;
  //   const finalTotal = totalPriceBeforeDiscount - discountAmount;

  //   setadminPrice(finalTotal - rate * slotCount);

  //   setpricePerHour(totalPriceBeforeDiscount.toFixed(2));
  //   setdiscountPrice(discountAmount.toFixed(2));
  //   setTotalCost(finalTotal.toFixed(2));
  //   if (selectedServiceType == "Full Support Counseling") {
  //     setpricePerHour(pricePerHour.toFixed(2));
  //   }
  // }, [slots, discount, selectedServiceObject, selectedServiceType]);

  useEffect(() => {
    const slotCount = parseInt(slots, 10);

    if (!selectedServiceObject || isNaN(slotCount)) {
      setTotalCost(0);
      setpricePerHour(0);
      setdiscountPrice(0);
      return;
    }

    let rate = 0;

    if (slotCount >= 1 && slotCount <= 4) {
      rate = parseFloat(selectedServiceObject?.rate_1_slot || "0");
    } else if (slotCount >= 5 && slotCount <= 9) {
      rate = parseFloat(selectedServiceObject?.rate_5_slot || "0");
    } else if (slotCount >= 10 && slotCount <= 14) {
      rate = parseFloat(selectedServiceObject?.rate_10_slot || "0");
    } else if (slotCount >= 15) {
      rate = parseFloat(selectedServiceObject?.rate_15_slot || "0");
    }

    const commission = parseFloat(selectedServiceObject?.commission || "0");

    setcounselorPrice(rate * slotCount);

    const price_Per_Hour = rate + (commission / 100) * rate;

    if (selectedServiceType == "Full Support Counseling") {
      // const totalPriceBeforeDiscount = price_Per_Hour * slotCount;
      // setpricePerHour(pricePerHour);
      // setpricePerHour(totalPriceBeforeDiscount.toFixed(2));
      const discountAmount = (discount / 100) * pricePerHour;
      const finalTotal = pricePerHour - discountAmount;
      // setadminPrice(finalTotal - rate * slotCount);
      setadminPrice((finalTotal - rate * slotCount).toFixed(2));
      setdiscountPrice(discountAmount.toFixed(2));
      setTotalCost(finalTotal.toFixed(2));
    } else {
      const totalPriceBeforeDiscount = price_Per_Hour * slotCount;
      const discountAmount = (discount / 100) * totalPriceBeforeDiscount;
      const finalTotal = totalPriceBeforeDiscount - discountAmount;
      setadminPrice((finalTotal - rate * slotCount).toFixed(2));
      setpricePerHour(totalPriceBeforeDiscount.toFixed(2));
      setdiscountPrice(discountAmount.toFixed(2));
      setTotalCost(finalTotal.toFixed(2));
    }
  }, [
    slots,
    discount,
    selectedServiceObject,
    selectedServiceType,
    pricePerHour,
  ]);

  return (
    <div>
      <ToastContainer />
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        gap={2}
      >
        <Typography textAlign="" fontWeight="bold" fontSize={18} mb={2}>
          Approve Slots
        </Typography>
        <Typography textAlign="" fontWeight="bold" fontSize={18} mb={2}>
          Available Slots {availableSlots}
        </Typography>
      </Box>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        gap={2}
      >
        <Autocomplete
          options={counselorList}
          getOptionLabel={(option) => `${option.firstName} ${option.lastName}`}
          value={selectedCounselors}
          onChange={(e, newValue) => {
            setSelectedCounselors(newValue);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select Counselor"
              placeholder="Choose counselor"
            />
          )}
          sx={{ width: 300 }}
        />

        <Autocomplete
          options={uniqueServiceTypes}
          value={selectedServiceType}
          onChange={(e, newValue) => setSelectedServiceType(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Service Type"
              placeholder="Select service type"
            />
          )}
          sx={{ width: 300 }}
          disabled={!selectedCounselors}
        />
      </Box>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
      >
        <Typography variant="h6" fontSize={18}>
          Number of slots{" "}
        </Typography>
        <TextField
          label="No. of Slots"
          type="number"
          value={slots}
          onChange={(e) => setSlots(e.target.value)}
          placeholder="Enter number of slots"
        />
      </Box>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
      >
        <Typography variant="h6" fontSize={18}>
          Discount{" "}
        </Typography>
        <TextField
          label="Discount (%)"
          type="number"
          value={discount}
          onChange={(e) => setDiscount(e.target.value)}
          placeholder="Enter discount percentage"
        />
      </Box>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
      >
        <Typography variant="h6" fontSize={18}>
          Total {/* Price/hour{" "} */}
        </Typography>
        {selectedServiceType === "Full Support Counseling" ? (
          <TextField
            // label="Price per Hour"
            label="Total"
            type="number"
            value={pricePerHour}
            onChange={(e) => setpricePerHour(e.target.value)}
          />
        ) : (
          <Typography variant="h6">${pricePerHour}</Typography>
        )}
        {/* <Typography variant="h6">${pricePerHour} </Typography> */}
      </Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
        mb={2}
      >
        <Typography variant="h6" fontSize={18}>
          Counselor Amount
        </Typography>
        <Typography variant="h6">${counselorPrice}</Typography>
      </Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
        mb={2}
      >
        <Typography variant="h6" fontSize={18}>
          Admin Amount
        </Typography>
        <Typography variant="h6">${adminPrice}</Typography>
      </Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
        mb={2}
      >
        <Typography variant="h6" fontSize={18}>
          Discount Amount
        </Typography>
        <Typography variant="h6">${discountPrice}</Typography>
      </Box>
      <Box sx={{ width: "100%", borderBottom: "1px solid black" }}>
        <Divider sx={{ color: "black" }} />
      </Box>

      <Box mt={2}>
        <Typography variant="h6" textAlign="right">
          Final Price: ${totalCost}
        </Typography>
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        mt={2}
        gap={2}
      >
        <Button
          variant="contained"
          color="error"
          p={2}
          onClick={() => {
            handleClose();
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="success"
          p={2}
          onClick={() => handleSendPayment()}
        >
          Send Payment Link
        </Button>
      </Box>
    </div>
  );
}
